document.addEventListener('DOMContentLoaded', function() {
    // The same JavaScript remains to control carousel scrolling and navigation.
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    
    const mediaCarousel = gallery.querySelector('media-carousel');
    const prevButton = gallery.querySelector('.product-gallery__nav--prev');
    const nextButton = gallery.querySelector('.product-gallery__nav--next');
    const currentSlideElement = gallery.querySelector('.current-slide');
    
    let currentSlide = 1;
    function updateSlideCounter(index) {
      currentSlideElement.textContent = index;
    }
    
    function updateButtonVisibility() {
      const slides = getSlides();
      prevButton.style.display = currentSlide === 1 ? 'none' : '';
      nextButton.style.display = currentSlide === slides.length ? 'none' : '';
    }
    
    function getSlides() {
    return Array.from(mediaCarousel.querySelectorAll('.product-gallery__media:not([data-stub])'));
  }
    
    function scrollToSlide(index) {
      const slides = getSlides();
      if (index < 0 || index >= slides.length) return;
      const slide = slides[index];
      const containerWidth = mediaCarousel.offsetWidth;
      const slideOffsetLeft = slide.offsetLeft;
      const slideWidth = slide.offsetWidth;
      const targetScrollLeft = slideOffsetLeft - (containerWidth - slideWidth) / 2;
      mediaCarousel.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    }
    
    function updateCurrentSlideByScroll() {
      const slides = getSlides();
      const carouselRect = mediaCarousel.getBoundingClientRect();
      let bestIndex = 0;
      let bestDistance = Infinity;
      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const carouselCenter = carouselRect.left + carouselRect.width / 2;
        const distance = Math.abs(carouselCenter - slideCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });
      currentSlide = bestIndex + 1;
      updateSlideCounter(currentSlide);
      updateButtonVisibility();
    }
    
    prevButton.addEventListener('click', function() {
      const slides = getSlides();
      currentSlide = currentSlide > 1 ? currentSlide - 1 : slides.length;
      scrollToSlide(currentSlide - 1);
      updateSlideCounter(currentSlide);
      updateButtonVisibility();
    });
    
    nextButton.addEventListener('click', function() {
      const slides = getSlides();
      currentSlide = currentSlide < slides.length ? currentSlide + 1 : 1;
      scrollToSlide(currentSlide - 1);
      updateSlideCounter(currentSlide);
      updateButtonVisibility();
    });
    
    let scrolling = false;
    mediaCarousel.addEventListener('scroll', function() {
      if (!scrolling) {
        window.requestAnimationFrame(function() {
          updateCurrentSlideByScroll();
          scrolling = false;
        });
        scrolling = true;
      }
    });
    
    updateButtonVisibility();
  });